import { LiveVideoFlight } from "@nova/protobuf"
import { Coordinate3D, ProjectWithMetadata } from "@nova/constants"
import { createFlightpathKML } from "@nova/data-create-flight-path-kml"

export const liveVideoFlightTransformer = (
    flight: LiveVideoFlight,
    project: ProjectWithMetadata,
    events: Coordinate3D[]
) => {
    return {
        flightpathKML: () => createFlightpathKML(flight.name + " Flightpath", [events], false),
        events,
        flight,
        project,
    }
}
